<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.question_show") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>

    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <base-select-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.question_category')"
            v-model.trim="data.categories"
            :optionsList="data.categories"
            disabled
            multiple
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.level')"
            v-model.trim="data.level.name"
            required
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.question_type')"
            v-model.trim="data.type.name"
            required
            disabled
          />
          <base-image-upload-input
            col="12"
            v-if="data.type?.value == 'video'"
            identifier="video"
            :placeholder="$t('PLACEHOLDERS.video_question')"
            :acceptVideo="true"
            @selectImage="selectVideo"
            :preSelectedImage="data.video.path"
          />
          <UploadAudio
            col="12"
            v-if="data.type?.value == 'record'"
            identifier="record"
            :placeholder="$t('PLACEHOLDERS.record_question')"
            :accepctAudio="true"
            @selectAudio="selectAudio"
            :multiple="false"
            :urls="[data.record]"
          />
          <div v-if="data.type?.value == 'image'">
            <h3>الصور</h3>
            <UploadsPhotos
              col="12"
              v-if="data.type?.value == 'image'"
              identifier="images"
              :urls="imgUrls"
              multiple
              :placeholder="$t('PLACEHOLDERS.image')"
              :acceptVideo="true"
              @onFileSelect="selectImages"
              @onFileRemove="onFileRemove"
            />
          </div>
          <!-- <base-input
            col="6"
            v-if="data.type.value"
            :type="data.type?.value != 'text' ? 'text' : 'textarea'"
            :placeholder="
              $t(
                data.type?.value == 'text'
                  ? 'PLACEHOLDERS.question_text_english'
                  : 'PLACEHOLDERS.descEn'
              )
            "
            v-model.trim="data.questionEn"
            required
          /> -->
          <base-input
            col="6"
            v-if="data.type"
            :type="data.type?.value != 'text' ? 'textarea' : 'textarea'"
            :placeholder="
              $t(
                data.type?.value == 'text'
                  ? 'PLACEHOLDERS.question_text_arabic'
                  : 'PLACEHOLDERS.descAr'
              )
            "
            v-model.trim="data.questionAr"
            required
          />

          <base-input
            col="6"
            :type="'textarea'"
            :placeholder="$t('PLACEHOLDERS.answer_text_arabic')"
            v-model.trim="data.answerAr"
            required
          />
          <!-- <base-input
            col="6"
            :type="'textarea'"
            :placeholder="$t('PLACEHOLDERS.answer_text_english')"
            v-model.trim="data.answerEn"
            required
          /> -->

          <base-select-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.objecting_clients')"
            v-model.trim="data.objected_users"
            :optionsList="data.objected_users"
            disabled
            multiple
          />
        </div>
        <div class="btn_wrapper">
          <base-button
            class="mt-2"
            styleType="primary_btn"
            :btnText="$t('BUTTONS.save')"
            :isLoading="isWaitingRequest"
            :disabled="isWaitingRequest"
          />
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import moment from "moment";
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";
import UploadAudio from "../../../components/formInputs/UploadAudio.vue";

export default {
  name: "CreatePackage",
  components: { UploadsPhotos, UploadAudio },

  data() {
    return {
      initialType: null,
      types: [
        {
          value: "text",
          name: this.$t("PLACEHOLDERS.text_queston"),
        },
        {
          value: "video",
          name: this.$t("PLACEHOLDERS.video_question"),
        },
        {
          value: "image",
          name: this.$t("PLACEHOLDERS.image_question"),
        },
        {
          value: "record",
          name: this.$t("PLACEHOLDERS.record"),
          id: "record",
        },
      ],
      levels: [
        {
          name: this.$t("PLACEHOLDERS.low"),
          value: "easy",
        },
        {
          name: this.$t("PLACEHOLDERS.medium"),
          value: "medium",
        },
        {
          name: this.$t("PLACEHOLDERS.hard"),
          value: "hard",
        },
      ],
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",
      imgUrls: [],

      // Start:: Data Collection To Send
      data: {
        images: [
          {
            path: null,
            file: null,
          },
        ],
        record: {
          path: null,
          file: null,
        },
        type: null,
        questionAr: null,
        questionEn: null,
        categories: [],
        objected_users: [],
        helping_answers: [],
        discount: null,
        helping_answersEn: ["", "", "", ""],
        helping_answersAr: ["", "", "", ""],
        question: null,
        video: {
          path: null,
          file: null,
        },
        image: {
          path: null,
          file: null,
        },
        name_ar: null,
        name_en: null,
        discount: null,
        discount_start_date: null,
        discount_end_date: null,
        number_of_available_usages: null,
        price: null,
        number_of_used: null,
        created_at: null,

        active: true,
      },
      // End:: Data Collection To Send
      capacities: [],
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  methods: {
    async getPackage() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `questions/${this.$route.params.id}`,
        });
        this.data.categories = res.data?.data.data?.categories;
        this.data.type = res.data.data?.data?.type;
        this.data.record.path = res.data.data.data?.record;
        this.data.video.path = res.data.data.data.video;
        this.data.questionAr = res.data.data.data.question_ar;
        this.data.questionEn = res.data.data.data.question_en;
        this.data.descAr = res.data.data.data.description_ar;
        this.data.descEn = res.data.data.data.description_en;
        this.data.answerAr = res.data.data.data.answer_ar;
        this.data.answerEn = res.data.data.data.answer_en;
        this.data.discount = res.data.data.data?.discount;
        this.data.hintAr = res.data.data.data.hint_ar;
        this.initialType = res.data.data.data.type;

        this.data.hintEn = res.data.data.data.hint_en;
        this.data.helping_answersAr = res.data.data.data.helping_answers_ar;
        this.data.helping_answersEn = res.data.data.data.helping_answers_en;
        this.data.images = res.data.data.data.image.map((image) => {
          return { file: null, path: image.url, id: image.id };
        });
        this.imgUrls = res.data.data.data.image.map((image) => image.url);

        this.data.record = res.data.data.data?.record;

        this.data.helping_answers = res.data.data.data?.helping_answers;
        this.data.answer = res.data.data?.data?.answer;
        this.data.objected_users = res.data.data?.data?.objected_users.map(
          (user) => {
            console.log(user);
            return {
              id: user.user_id,
              name: `${user.user_name} - ${user.objection_date}`,
            };
          }
        );
        this.data.type = this.types?.find(
          (type) => type.value == res.data.data.data.type
        );
        this.data.level = this.levels?.find(
          (level) => level.value == res.data.data.data.level
        );
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },
    selectAudio(selectedAudio) {
      this.data.record = {
        file: selectedAudio[0],
        path: null,
      };
    },
    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },
    selectImages(selectedImage) {
      this.data.images = [...this.data.images, ...selectedImage];
    },
    async onFileRemove(index) {
      this.$delete(this.imgUrls, index);

      const imageId = this.data.images[index]?.id;

      if (!imageId) return;
      try {
        await this.$axios({
          method: "DELETE",
          url: `delete-media/${imageId}`,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.deletedSuccessfully"));
        this.$delete(this.imgUrls, index);
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }

      this.data.filter.images.filter((image, i) => index != i);
    },
    selectVideo(selectedVideo) {
      this.data.video = selectedVideo;
    },
    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      this.submitForm();
    },
    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.data.type.value == "record" && this.data.record.file) {
        REQUEST_DATA.append("record", this.data.record.file);
      }
      if (this.data.type.value == "image" && this.data.images) {
        this.data.images.map((image) => {
          if (!image.path) REQUEST_DATA.append("images[]", image);
        });
      }
      if (this.data.type.value == "video" && this.data.video.file) {
        console.log(this.data.video.file);
        REQUEST_DATA.append("video", this.data.video.file);
      }
      console.log(this.data.type?.value, this.initialType);
      if (this.data?.type && this.data.type?.value != this.initialType) {
        REQUEST_DATA.append("type", this.data.type?.value);
      }

      if (this.data.questionAr) {
        REQUEST_DATA.append("question[ar]", this.data.questionAr);
      }
      if (this.data.questionEn) {
        REQUEST_DATA.append("question[en]", this.data.questionEn);
      }
      if (this.data.answerAr) {
        REQUEST_DATA.append("answer[ar]", this.data.answerAr);
      }
      if (this.data.answerEn) {
        REQUEST_DATA.append("answer[en]", this.data.answerEn);
      }
      if (this.data.level) {
        REQUEST_DATA.append("level", this.data.level?.value);
      }
      if (this.data.hintAr) {
        REQUEST_DATA.append("hint[ar]", this.data.hintAr);
      }
      if (this.data.hintAr) {
        REQUEST_DATA.append("hint[en]", this.data.hintEn);
      }
      if (this.data.helping_answersAr) {
        this.data.helping_answersAr.forEach((answer, i) => {
          REQUEST_DATA.append(`helping_answers[ar][${i}]`, answer);
        });
      }

      if (this.data.helping_answersEn) {
        this.data.helping_answersEn.forEach((answer, i) => {
          REQUEST_DATA.append(`helping_answers[en][${i}]`, answer);
        });
      }

      REQUEST_DATA.append("_method", "PUT");
      try {
        await this.$axios({
          method: "POST",
          url: `questions/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/disputed-questions/all" });
      } catch (error) {
        console.log(error);
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
  },

  created() {
    // Start:: Fire Methods
    // End:: Fire Methods
    this.getPackage();
  },
};
</script>
